export function ok(value) {
    return { ok: true, value };
}
export function err(error) {
    return { ok: false, error };
}
export function isOk(r) {
    return r.ok;
}
export function isErr(r) {
    return !r.ok;
}
export function map(r, f) {
    return r.ok ? ok(f(r.value)) : r;
}
export function mapErr(r, f) {
    return r.ok ? r : err(f(r.error));
}
export function andThen(r, f) {
    return r.ok ? f(r.value) : r;
}
export async function andThenAsync(r, f) {
    return r.ok ? await f(r.value) : r;
}
export function unwrap(r) {
    if (!r.ok) {
        throw new Error(`unwrap on err: ${JSON.stringify(r.error)}`);
    }
    return r.value;
}
//# sourceMappingURL=result.js.map